module.exports = __webpack_public_path__ + "img/0Q3A5746_L_Foamcore_MockedUp.04135fa9.jpg";